import React, { useState, useEffect } from 'react';
import { Container, Chip, Grow, Grid, Paper, Button, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
// import { useLocation } from 'react-router-dom';
import { createProject, updateProject } from '../../actions/projects';
import defaultImage from '../../assets/icons/defaultImage.png';
import Input from '../Auth/Input/Input';

// import Projects from '../Projects/Projects';
// import Form from '../Form/Form';
// import Pagination from '../Pagination/Pagination';
import useStyles from './styles';
// import useCommonStyles from './../CommonStyle/commonStyle';
import { store } from '../../index';
import uploadIcon from '../../assets/icons/upload_icon.svg';

type RootState = ReturnType<typeof store.getState>;
// import { classes } from 'istanbul-lib-coverage';

// function useQuery() {
//     return new URLSearchParams(useLocation().search);
// }

const ProjectForm = () => {
    // const query = useQuery();
    const [currentId, setCurrentId] = useState(null);
    const dispatch = useDispatch();
    const classes = useStyles();
    // const commonClasses = useCommonStyles();
    // const history = useHistory();

    const tagList: string[] = ["#フードロス", "#ごみ問題", "#健康と福祉", "#気候変動", "#ジェンダー", "#テクノロジー", "#生活", "#権利", "#貧困", "#動物愛護", "#ファッション", "#政治", "#農業", "#漁業", "#平和・公正"]
    const initialProjectData = { title: '', purpose: '', goal: '', resources: '', description: '', status: '', message: '', members: '', tags: [''], selectedFile: '', imageUrl:'', imageUpdated: false};
    const [projectData, setProjectData] = useState(initialProjectData);
    const project = useSelector((state: RootState) => currentId ? state.projects.projects.find((p) => p._id === currentId) : null);
    const user = JSON.parse(localStorage.getItem('profile') || '{ "result": { "name": "","imageUrl": ""}}');

    //@ts-ignore
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setProjectData({ ...projectData, [e.target.name]: e.target.value });

    };

    useEffect(() => {
        //@ts-ignore
        if (project) setProjectData({ ...project});
    }, [project]);


    // useEffect(() => {
    //     //@ts-ignore
    //     if (project) setProjectData(project);
    // }, [project]);

    const clear = () => {
        setCurrentId(null);
        setProjectData(initialProjectData);
    };

    //@ts-ignore
    const handleSubmit = (e) => {
        e.preventDefault();

        if (currentId) {
            if(projectData.selectedFile!=='') projectData.imageUpdated=true;
            dispatch(updateProject(currentId, { ...projectData, name: user?.result?.name }));
            clear();
            console.log("with currentID");
        } else {
            const newTags = projectData.tags.filter((tag) => tag !== "");
            projectData.tags = newTags;
            dispatch(createProject({ ...projectData, name: user?.result?.name }));
            clear();
            console.log("without currentID");

        }
    }

    const hiddenImageInput = React.useRef(null);

    const handleClick = (e: any) => {
        //@ts-ignore
        hiddenImageInput.current.click();
    };

    const handleImage = async (e: any) => {
        if (e.target.name === "upload") {
            //@ts-ignore
            const file = e.target.files[0];
            const base64 = await convertBase64(file);
            //@ts-ignore
            setProjectData({ ...projectData, selectedFile: base64 });
        }
        else if (e.type === "click") {
            //@ts-ignore
            setProjectData({ ...projectData, selectedFile: '' });
        }
    };
    const convertBase64 = (file: any) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);

            fileReader.onload = () => {
                resolve(fileReader.result);
            };

            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };
    //@ts-ignore
    const chipClick = (e) => {
        const tagClicked = e.target.innerText.slice(1);
        // console.log(e.target.innerText);
        if (projectData.tags.includes(tagClicked)) {
            const newTags = projectData.tags.filter((tag) => tag !== tagClicked);
            setProjectData({ ...projectData, tags: newTags });
        }
        else {
            const newTags = [...projectData.tags, tagClicked];
            setProjectData({ ...projectData, tags: newTags });
        }
    };



    return (
        <Grow in>
            <Container maxWidth="lg">
                <Paper className={classes.paper} elevation={3}>
                    <Grid container direction="column" justifyContent="center" alignItems="center" spacing={3} className={classes.parentGridContainer}>
                        <form autoComplete="off" noValidate className={`${classes.root} ${classes.form}`} onSubmit={handleSubmit} >
                            {Boolean(projectData.selectedFile) ?

                                <Container className={classes.imageParentDiv}>
                                    <img src={projectData.selectedFile} className={classes.image} alt="Selected"/>
                                    <Button onClick={handleClick} className={classes.imageEdit}>
                                        <div>
                                            <img src={uploadIcon} className={classes.uploadIcon} alt="New"/>
                                            <br />
                                            <Typography className={classes.uploadText} > 画像を変更 </Typography>
                                        </div>
                                    </Button>
                                    <input name="upload" type="file"
                                        ref={hiddenImageInput}
                                        onChange={handleImage}
                                        style={{ display: 'none' }} />

                                    <Button name="delete" onClick={handleImage} className={classes.deleteButton}>
                                        削除
                                    </Button>
                                </Container>

                                :
                                <Container className={classes.imageParentDiv}>
                                    <img src={projectData.imageUrl||defaultImage} className={classes.image} alt="Selected"/>
                                    <Button name="upload" onClick={handleClick} className={classes.imageEdit} >
                                        <div>
                                            <img src={uploadIcon} className={classes.uploadIcon} alt="New"/>
                                            <br />
                                            <Typography className={classes.uploadText} >画像をアップロード</Typography>
                                        </div>
                                    </Button>
                                    <input name="upload" type="file"
                                        ref={hiddenImageInput}
                                        onChange={handleImage}
                                        style={{ display: 'none' }} />
                                </Container>
                            }
                            <div className={classes.cardInnerDiv}>
                                <Input name="title" label="タイトル" handleChange={handleChange} multiline value={projectData.title} />
                                <Input name="purpose" label="目的" rows={5} handleChange={handleChange} multiline value={projectData.purpose} />
                                <Input name="goal" label="目標" rows={5} handleChange={handleChange} multiline value={projectData.goal} />
                                <Input name="resources" label="求めてるリソース" rows={5} handleChange={handleChange} multiline value={projectData.resources} />
                                <Input name="message" label="概要" rows={5} handleChange={handleChange} multiline value={projectData.message} />
                                <Input name="status" label="現状" rows={5} handleChange={handleChange} multiline value={projectData.status} />

                                <Typography className={classes.tagTitle}>カテゴリー * </Typography>

                                <Grid container className={classes.tagListGrid} direction="row" justifyContent="center">
                                    {tagList.map((tag, index) => {
                                        if (projectData.tags.includes(tag.slice(1))) { return (<Chip key={index} onClick={chipClick} label={tag} className={classes.tagChipClicked} />) }
                                        else { return (<Chip key={index} onClick={chipClick} label={tag} className={classes.tagChip} />) }
                                    })}
                                </Grid>
                                <div className={classes.buttonsParent}>
                                <Button className={classes.buttonClear} variant="contained" color="inherit" size="large" onClick={clear}>クリア</Button>
                                <Button className={classes.buttonSubmit} variant="contained" color="primary" size="large" type="submit">プロジェクト投稿</Button>

                                </div>
                               
                            </div>

                        </form>

                    </Grid>
                </Paper>
            </Container>
        </Grow>
    )
};

export default ProjectForm;